'use client'

import {Grid} from "@mui/material";
import React, {useState} from "react";
import StudentLoginFields from "@/app/students/login/studentLoginFields";
import StudentRegistration from "@/app/students/login/studentRegisteration";
import ForgotPassword from "@/components/admin/login/forgotPassword";
import NewPassword from "@/components/admin/login/newPassword";
import Cookies from "js-cookie";
import SafeHtml from "@/components/snackbar/safeHTML";
import ActionButtons from "@/components/dialogs/actionButtons";
import Dialogs from "@/components/dialogs";
import {DialogControl} from "@/components/dialogs/types";
import {useTranslation} from "react-i18next";
import {AsyncCookie} from "@/components/shared/client/utils";
import {useGetSiteSettingsForUsersQuery} from "@/redux/rtk/students/shared";
import {SITE_SETTINGS_OPTIONS} from "@/app/admin/siteSettings/registrationForm/page";
import {GENERAL_OBJECT} from "@/components/types";


const StudentLoginPageStepper = () => {
    const {t} = useTranslation();
    const cookieName = process.env.NEXT_PUBLIC_COOKIE_PREFIX + "_" + "SITE_CONSENT";
    const value: string = Cookies.get(cookieName) ?? "";
    const [step, setStep] = useState<number>(1);
    const {data} = useGetSiteSettingsForUsersQuery(1);
    const [openDialog, setOpenDialog] = useState<DialogControl>({
        open: !Boolean(value)
    });
    const [fields, setFields] = useState<GENERAL_OBJECT>({
        email: "",
        duration: 0,
        cycleId: 1,
        dateOfBirth: null
    });

    const siteSettings: SITE_SETTINGS_OPTIONS | null = data?.data?.siteSettings?.length > 0 ? JSON.parse(data.data.siteSettings[0].settings) : null;

    const handleFormSubmission = () => {
        AsyncCookie.setCookie(cookieName, 1, 365)
        setOpenDialog({
            open: false
        })
    }


    return <Grid className="df we1 mhe1 hfc">
        <Dialogs
            noCloseIcon={true}
            open={openDialog}
            children={
                <>
                    <Grid container className="df we1"><SafeHtml html={t("cookieText")}/></Grid>
                    <Grid container className="df we1" sx={{mt: 2}}><SafeHtml html={t("cookieTextUrdu")}/></Grid>
                </>
            }
            onSubmit={handleFormSubmission}
            actionButtons={
                <ActionButtons
                    actionButtonLabel={t('global:accept')}
                    noCancelButton={true}
                    handleClose={() => console.log("accept cookies")}
                    t={t}
                    onClick={handleFormSubmission}
                    loading={false}
                    disabled={false}
                />
            }
            handleClose={() => console.log("accept cookies")}
            title={t('global:acceptCookies')}
        >

        </Dialogs>
        {step === 1 && <StudentLoginFields setStep={setStep} fields={fields} setFields={setFields} />}
        {step === 2 && <ForgotPassword fields={fields} setFields={setFields} setStep={setStep} />}
        {step === 3 && <NewPassword fields={fields} setFields={setFields} setStep={setStep} />}
        {step === 4 && <StudentRegistration siteSettings={siteSettings} setStep={setStep} fields={fields} setFields={setFields} />}
    </Grid>
}

export default StudentLoginPageStepper;